import React from "react";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import {
  DoorGlassMaterial,
  getFramePositions,
  getFrameScaling,
} from "../../../../../shared/utils/door";
import { RailSettings } from "shared/utils/doorConfigurations";

interface RailsProps {
  doorNodes: any;
  materials: DoorGlassMaterial;
  index: number;
  railSettings?: RailSettings;
}

const Rails: React.FC<RailsProps> = ({
  doorNodes,
  materials,
  index,
  railSettings,
}: RailsProps) => {
  const {
    getConfigurationColor,
    getConfigurationHeight,
    getConfigurationWidth,
  } = useConfigurationOptionsContext();

  const height = getConfigurationHeight(index);
  const width = getConfigurationWidth(index);

  const positions = getFramePositions(width, height);
  const scaling = getFrameScaling(width, height);

  return (
    <group
      position-y={railSettings?.generalRailShiftY ?? 0}
      scale-x={railSettings?.generalRailScaleX ?? 1}
    >
      <mesh
        geometry={doorNodes["rails_0"].geometry}
        material={materials[getConfigurationColor()]}
        scale={[scaling.horizontal.x, railSettings?.scaleY || 1, 1]}
        position={[
          -positions.left.x + 0.4 * (1 - scaling.horizontal.x),
          positions.top.y + (railSettings?.shiftY || 0),
          0,
        ]}
      ></mesh>
      <mesh
        geometry={doorNodes["rails_1"].geometry}
        material={materials[getConfigurationColor()]}
        position={[positions.left.x, positions.top.y, 0]}
      ></mesh>
      <mesh
        geometry={doorNodes["rails_2"].geometry}
        material={materials[getConfigurationColor()]}
        position={[positions.right.x, positions.top.y, 0]}
      ></mesh>
    </group>
  );
};

export default Rails;
